import { combineReducers } from 'redux';

import auth from './auth';
import isLoading from './loading';
import modal from './modal';
import interview from './mockInterview';
import interviewTest from './mockInterviewTest';
import review from './review';
import isHideVideo from './isHideVideo';
import questionsList from './questionsList';
import browseQuestions from './browseQuestions';
import interviewForSession from './mockInterviewForSession';
import interviewSession from './interviewSession';
import interviewFinalQuestions from './interviewFinalQuestions';
import feedback from './feedback';

const rootReducer = combineReducers({
  auth,
  isLoading,
  modal,
  interview,
  interviewTest,
  review,
  isHideVideo,
  questionsList,
  browseQuestions,
  interviewForSession,
  interviewSession,
  interviewFinalQuestions,
  feedback,
});

export default rootReducer;
